/* eslint-disable unicorn/filename-case */
export interface PreventiveMEDto {
  binusianId: string;
  id: string;
  location: string;
  name: string;
  link: string;
  type: "DAILY" | "QUARTERLY";
}

export namespace PreventiveMEDto {
  export function toCreateJSON(data: PreventiveMEDto) {
    return {
      binusianId: data.binusianId,
      locationId: data.location,
      preventiveMEName: data.name,
      preventiveMEUrl: data.link,
      category: data.type,
    };
  }
  export function toUpdateJSON(data: PreventiveMEDto) {
    return {
      binusianId: data.binusianId,
      preventiveMEID: data.id,
      locationId: data.location,
      preventiveMEName: data.name,
      preventiveMEUrl: data.link,
      category: data.type,
    };
  }
}
